import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  constructor() { }

  @Input() model: boolean | undefined = false;

  @Output() modelChange = new EventEmitter<boolean>();

  ngOnInit(): void {
  }

  toggleValue() {
    this.model = !this.model;
    this.modelChange.emit(this.model);
  }

}
